import { CardConditionalHighlight, CardTitle } from "../common";
import React, { useImperativeHandle } from "react";
import { faLink, faPlayCircle } from "@fortawesome/free-solid-svg-icons";

import { Card } from "@material-tailwind/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RequestCard = React.forwardRef(
  (
    {
      card,
      topic,
      messages,
      w,
      h,
      executeRequest,
      displayVariant,
      displayParameters,
    },
    ref
  ) => {
    const action = (setSelectedCard) => {
      setSelectedCard(card);
    };

    useImperativeHandle(ref, () => ({ action }));

    // Create a safe messages array; we're not using lastMessage here for URL extraction.
    const safeMessages = messages && messages.length > 0 ? messages : [];
    // We'll derive content and method from displayParameters (or fallback to topic.display_parameters)
    const params = displayParameters || card.params || {};
    const content = params.url || "";
    const method = params.method || "GET";

    const sizeKey = `${w}x${h}`;

    const renderContent = () => {
      switch (sizeKey) {
        case "1x1":
        case "1x2":
          return (
            <div className="flex items-center justify-center w-full h-full">
              <FontAwesomeIcon
                icon={faPlayCircle}
                className="text-gray-700 text-4xl"
              />
            </div>
          );
        case "1x3":
        case "3x1":
          return (
            <div className="flex items-center justify-center w-full h-full">
              <FontAwesomeIcon
                icon={faPlayCircle}
                className="text-gray-700 text-3xl mr-2"
              />
              <CardTitle title={topic.name} />
            </div>
          );
        case "2x1":
        case "2x2":
        case "2x3":
        case "3x2":
        case "3x3":
          return (
            <div className="flex flex-col justify-between w-full h-full bg-ghost-white">
              <CardTitle title={topic.name} />
              <div className="flex items-center text-gray-700 truncate">
                <FontAwesomeIcon icon={faLink} className="mr-1" />
                <a
                  href={content}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs truncate hover:underline interactive-element"
                >
                  {content}
                </a>
              </div>
              <button
                onClick={handleButtonClick}
                onTouchEnd={handleButtonClick}
                className="interactive-element w-1/2 mx-auto bg-gray-100 text-gray-700 px-4 py-1 rounded-lg hover:bg-sunset transition-colors duration-300 flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faPlayCircle} className="mr-2" />{" "}
                {method}
              </button>
            </div>
          );
        default:
          return (
            <div className="flex flex-col justify-between w-full h-full">
              <CardTitle title={topic.name} />
              <button
                onClick={handleButtonClick}
                onTouchEnd={handleButtonClick}
                className="interactive-element w-1/2 mx-auto bg-gray-100 text-gray-700 px-4 py-1 rounded-lg hover:bg-sunset transition-colors duration-300 flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faPlayCircle} className="mr-2" />{" "}
                {method}
              </button>
              <div className="flex items-center mt-2 text-indigo-400 truncate">
                <FontAwesomeIcon icon={faLink} className="mr-1" />
                <a
                  href={content}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs truncate hover:underline interactive-element"
                >
                  {content}
                </a>
              </div>
            </div>
          );
      }
    };

    const handleButtonClick = (e) => {
      executeRequest(card);
    };

    return (
      <CardConditionalHighlight card={card}>
        <div className="p-2 w-full h-full bg-ghost-white">
          {renderContent()}
        </div>
      </CardConditionalHighlight>
    );
  }
);

RequestCard.variants = ["default"];
RequestCard.variantParameters = {
  default: {
    url: {
      label: "URL",
      type: "string",
      default: "",
    },
    method: {
      label: "Method",
      type: "option",
      options: ["GET", "POST", "PUT", "DELETE"],
      default: "GET",
    },
    headers: {
      label: "Headers",
      type: "map",
      default: [{ key: "Content-Type", value: "application/json" }],
    },
    // body: {
    //   label: "Body / JSON",
    //   type: "code",
    //   default: "",
    // },
  },
  post: {},
};

export default RequestCard;
